import { render, staticRenderFns } from "./BuyingGroupDetail.vue?vue&type=template&id=57b9d0e1&"
import script from "./BuyingGroupDetail.vue?vue&type=script&lang=js&"
export * from "./BuyingGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports